/* eslint-disable no-console */

import { transformValues } from './transformValues';

export function transformFields(response, addressFieldMap) {
  console.log('Address result ---------------------');
  if (!response || !response.suggestions || !response.suggestions.length) {
    console.log('None');
    return false;
  }
  console.log(response.suggestions[0].data);

  return Object.keys(addressFieldMap).reduce((data, fieldName) => {
    const serviceFieldNames =
      typeof addressFieldMap[fieldName] === 'string'
        ? [addressFieldMap[fieldName]]
        : addressFieldMap[fieldName];

    if (!serviceFieldNames) {
      data[fieldName] = undefined;
      return data;
    }

    let nextSeparator = '';

    data[fieldName] = serviceFieldNames.reduce(
      (concatenatedValue, serviceFieldName) => {
        let value = '';
        // Look for a preconfigured suffix, prefix or separator.
        // Separator sample: '{, }' ==> ', '
        // Prefix sample: '{House nr. }HouseNumber' ==> 'House nr. 123'
        // Suffix sample: 'HouseNumber{ (House number)}' ==> '123 (House number)'
        const suffixPrefixOrSeparatorMatch = serviceFieldName.match(/\{(.*)\}/);

        if (suffixPrefixOrSeparatorMatch) {
          if (suffixPrefixOrSeparatorMatch[0] === serviceFieldName) {
            nextSeparator = suffixPrefixOrSeparatorMatch[1];
            return concatenatedValue;
          }

          const key = serviceFieldName.replace(
            suffixPrefixOrSeparatorMatch[0],
            ''
          );
          const fieldValue = response.suggestions[0].data[key];
          value = fieldValue
            ? serviceFieldName
                .replace(
                  suffixPrefixOrSeparatorMatch[0],
                  suffixPrefixOrSeparatorMatch[1]
                )
                .replace(key, fieldValue)
            : '';
        } else {
          value = response.suggestions[0].data[serviceFieldName];
        }
        const separator = concatenatedValue ? nextSeparator : '';

        const newConcatenatedValue = value
          ? `${concatenatedValue}${separator}${value}`
          : concatenatedValue;

        nextSeparator = '';
        return newConcatenatedValue;
      },
      ''
    );
    return data;
  }, {});
}

export { transformValues };

export function transformOptions(response, searchQuery) {
  console.log('Address options ---------------------');
  console.log(response.suggestions);

  if (!response || !response.suggestions || !response.suggestions.length) {
    return false;
  }

  const options = [];

  for (let i = 0; i < response.suggestions.length; i++) {
    options.push({
      id: `complete-option-${i}`,
      label: response.suggestions[i].unrestricted_value,
      // subLabel: undefined,
      isCapturable:
        response.suggestions.length > 0 ||
        response.suggestions[i].unrestricted_value === searchQuery
    });
  }

  return options;
}
